var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vSelect',_vm._g(_vm._b({ref:"vSelect",on:{"close":_vm.handleOptionSelected}},'vSelect',_vm.$attrs,false),_vm.$listeners),[_c('div',{attrs:{"slot":"no-options"},slot:"no-options"},[_vm._v(_vm._s(_vm.$t('SEARCH_SELECT.NO_OPTIONS')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }